module.exports = __webpack_public_path__ + "img/slide-3.cf23f3db.png";